import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Mirrors the "Show Additional Columns" pill-style toggle used on the Budget Groups
// table (see BudgetTableCss.jsx / BudgetGroupsTable.jsx), reused here so redux-form
// boolean fields (e.g. Run Default Jobs) can render with the same look and feel.

const ToggleWrapOuter = styled.div`
display: flex;
align-items: center;

& > div {
  width: auto;
}
`;

const ToggleSlide = ({ name, setFunction, currentState, bgColor, isDarkMode }) => {
  const togglePosition = !currentState ? 'left' : 'right';
  const ToggleLabel = styled.button`
    cursor: pointer;
    text-indent: -9999px;
    width: 40px;
    height: 20px;
    display: block;
    border-radius: 23px;
    position: relative;
    margin-bottom: 0;
    border: none;
    background-color: #899499;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      ${togglePosition}: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      transition: 0.3s;
      box-shadow: 0 5px 10px rgba(153, 153, 153, 0.4);
      background-color: #ffffff;
    }
  `;

  const ToggleWrap = styled.div`
    justify-content: flex-start;
    display: inline-flex;
    width: 100%;
    padding: 4px 0;
    margin-bottom: 0;
    cursor: pointer;
    color: ${isDarkMode ? '#dddddd' : '#646777'};

    input {
      height: 0;
      width: 0;
      visibility: hidden;

      &:checked ~ ${ToggleLabel} {

        &:after {
          background: ${bgColor};
          left: 100%;
          transform: translateX(-100%);
        }
      }
    }
  `;

  return (
    <>
      {name}: &nbsp;&nbsp;
      <ToggleWrap>
        <input name={name} type="checkbox" checked={currentState} onChange={setFunction} />
        <ToggleLabel
          type="button"
          onClick={setFunction}
        >
          Toggle {name}
        </ToggleLabel>
      </ToggleWrap>
    </>
  );
};

ToggleSlide.propTypes = {
  name: PropTypes.string.isRequired,
  setFunction: PropTypes.func.isRequired,
  currentState: PropTypes.bool.isRequired,
  bgColor: PropTypes.string,
  isDarkMode: PropTypes.bool,
};

ToggleSlide.defaultProps = {
  bgColor: '#91BE23',
  isDarkMode: false,
};

// redux-form <Field component={renderToggleField} /> adapter around ToggleSlide.
export const renderToggleField = ({ input, label, bgColor, isDarkMode }) => (
  <ToggleSlide
    name={label}
    currentState={!!input.value}
    setFunction={() => input.onChange(!input.value)}
    bgColor={bgColor}
    isDarkMode={isDarkMode}
  />
);

renderToggleField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func,
  }).isRequired,
  label: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  isDarkMode: PropTypes.bool,
};

renderToggleField.defaultProps = {
  bgColor: '#91BE23',
  isDarkMode: false,
};

export {
  ToggleWrapOuter,
  ToggleSlide,
};
